import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 12v-5c0 -1.105 -.895 -2 -2 -2h-.5c-.276 0 -.5 -.224 -.5 -.5s-.224 -.5 -.5 -.5h-3c-.276 0 -.5 .224 -.5 .5s-.224 .5 -.5 .5h-.5c-1.105 0 -2 .895 -2 2v11c0 1.105 .895 2 2 2h6","key":"svg-0"}],["path",{"d":"M19 16v3","key":"svg-1"}],["path",{"d":"M19 22v.01","key":"svg-2"}]]

const IconBatteryVerticalExclamation = createReactComponent('outline', 'battery-vertical-exclamation', 'BatteryVerticalExclamation', __iconNode);

export default IconBatteryVerticalExclamation;